import { UTP } from 'shared/landingSeller/constants/sellWithCianIUtp';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { ITypographyComponentProps, TMemoForwardRefComponent } from '@cian/ui-kit';
import { TWithModalProps } from 'shared/common/types/components';
import * as React from 'react';

interface ISellWithCianProps extends TWithModalProps {
  ItemTitle: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  garantLabel: React.ReactNode;
}

export const SellWithCian: React.FC<ISellWithCianProps> = ({ device, ItemTitle, garantLabel }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <h3 className={style['title']}>Что вы получите</h3>
      <div className={style['items']}>
        <div className={style['items-row']}>
          {UTP.map(({ title, toolTipText, imageClass }, index) => (
            <div className={style['item']} key={index}>
              <div className={clsx(style['item-image'], style[imageClass])} />
              <div className={style['item-title']}>
                <ItemTitle color="text-primary-default">{title}</ItemTitle>
              </div>
              <div className={style['item-descr']}>{toolTipText}</div>
            </div>
          ))}
          <div className={style['item-with-label']}>
            <div className={clsx(style['item'], style['item-accent'])}>
              <div className={clsx(style['item-image'], style['pay'])} />
              <div className={style['item-title']}>
                <ItemTitle color="theme-white">Почувствуете себя комфортно</ItemTitle>
              </div>
              <div className={style['item-descr']}>Специалист Циана курирует сделку и защищает ваши интересы</div>
            </div>

            {garantLabel}
          </div>
        </div>
      </div>
    </div>
  );
};
